import {
  hydrateCustomers,
  hydrateDeals,
  hydrateFavoriteDeals,
  hydrateNotifications,
} from '@/models/hydrate';
import { useEffect } from 'react';

const useSideBarHydrateLatest = () => {
  useEffect(() => {
    const hydrateSideBar = async () => {
      await Promise.all([
        hydrateFavoriteDeals(),
        hydrateCustomers(),
        hydrateDeals(),
        hydrateNotifications(),
      ]);
    };

    hydrateSideBar();
  }, []);
};

export default useSideBarHydrateLatest;
